import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import userService from '../user.service.js';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import colors from '../shared-colors';
import welcomeImage from '../images/Onboarding/welcome.png';
import caregiverImage from '../images/Onboarding/caregiver.png';
import activityImage from '../images/Onboarding/activity.png';
import reportsImage from '../images/Onboarding/reports.png';
import { t } from 'i18next';

const styles = (theme) => ({
  paper: {
    background: '#FFFFFF',
    // height: '620px',
    padding: '24px 32px 24px 32px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    ['@media (min-width:600px)']: {
      // eslint-disable-line no-useless-computed-key
      width: '440px',
    },
    ['@media (max-width:600px)']: {
      // eslint-disable-line no-useless-computed-key
      width: '340px',
      padding: '16px',
      backgroundSize: 'contain',
      backgroundPosition: 'center top',
    },
    ['@media (max-width:470px)']: {
      // eslint-disable-line no-useless-computed-key
      width: 'auto',
    },
  },

  topContainer: {
    marginTop: '300px',
    width: '100%',
    ['@media (max-width:600px)']: {
      // eslint-disable-line no-useless-computed-key
      marginTop: '270px',
    },
    ['@media (max-width:470px)']: {
      // eslint-disable-line no-useless-computed-key
      marginTop: '230px',
    },
  },
  mainContainer: {
    // marginTop: '140px',
  },
  mainText: {
    fontSize: '24px',
    fontWeight: 800,
    marginBottom: '10px',
    textAlign: 'center',
    ['@media (min-width:470px)']: {
      // eslint-disable-line no-useless-computed-key
      width: '300px',
    },
  },
  explanationText: {
    fontSize: '16px',
    textAlign: 'center',
    marginBottom: '10px',
    color: colors.grayText,
    ['@media (min-width:470px)']: {
      // eslint-disable-line no-useless-computed-key
      width: '320px',
    },
  },
  stepCircle: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    display: 'inline-block',
    marginLeft: '6px',
    marginRight: '6px',
  },
  activeStepCircle: {
    background: colors.mainBlue,
  },
  lightCircle: {
    background: colors.blue,
  },

  footer: {
    marginTop: '20px',
  },
  cancelButton: {
    color: colors.grayText,
  },
  saveButton: {
    // marginLeft: '8px',
  },
});

const useStyles = makeStyles(styles);

function Onboarding({ user, refresh, closeModal }) {
  const classes = useStyles();
  const steps = ['welcome', 'caregivers', 'activity', 'reports']; // order of onboarding
  const images = [welcomeImage, caregiverImage, activityImage, reportsImage];
  const [state, setState] = useState({
    step: 0,
  });
  const lastStep = state.step === steps.length - 1;

  function nextStep() {
    if (lastStep) {
      localStorage['notFirstVisit'] = true;
      closeModal();
    } else {
      setState({ step: (state.step += 1) });
    }
  }

  return (
    <div
      className={classes.paper}
      style={{
        backgroundImage: `url(${images[state.step]})`,
      }}
    >
      <Grid container item direction="column" justify="flex-start" alignItems="center" className={classes.topContainer}>
        {steps[state.step] === 'welcome' && (
          <Grid
            container
            item
            direction="column"
            justify="flex-start"
            alignItems="center"
            className={classes.mainContainer}
          >
            <Grid item className={classes.mainText}>
              {t('welcome_message')}
            </Grid>
            <Grid item className={classes.explanationText}>
              {t('welcome_message_para')}
            </Grid>
          </Grid>
        )}
        {steps[state.step] === 'caregivers' && (
          <Grid
            container
            item
            direction="column"
            justify="flex-start"
            alignItems="center"
            className={classes.mainContainer}
          >
            <Grid item className={classes.mainText}>
              {t('caregivers_and_emergency_contacts')}
            </Grid>
            <Grid item className={classes.explanationText}>
              {t('caregivers_and_emergency_contacts_para')}
            </Grid>
          </Grid>
        )}
        {steps[state.step] === 'activity' && (
          <Grid
            container
            item
            direction="column"
            justify="flex-start"
            alignItems="center"
            className={classes.mainContainer}
          >
            <Grid item className={classes.mainText}>
              {t('change_and_reach_your_goal')}
            </Grid>
            <Grid item className={classes.explanationText}>
              {t('change_and_reach_your_goal_para')}
            </Grid>
          </Grid>
        )}
        {steps[state.step] === 'reports' && (
          <Grid
            container
            item
            direction="column"
            justify="flex-start"
            alignItems="center"
            className={classes.mainContainer}
          >
            <Grid item className={classes.mainText}>
              {t('adjust_reports_settings')}
            </Grid>
            <Grid item className={classes.explanationText}>
              {t('adjust_reports_settings_para')}
            </Grid>
          </Grid>
        )}
        <Grid item className={classes.stepNumberIndicator}>
          {_.map(steps, (step, index) => {
            if (state.step === index) {
              return <div className={`${classes.stepCircle} ${classes.activeStepCircle}`} />;
            }

            return <div className={`${classes.stepCircle} ${classes.lightCircle}`} />;
          })}
        </Grid>
      </Grid>
      <Grid container item direction="row" justify="space-between" alignItems="center" className={classes.footer}>
        <Grid item>
          <Button
            fullWidth
            // variant="outlined"
            className={classes.cancelButton}
            onClick={() => {
              localStorage['notFirstVisit'] = true;
              closeModal();
            }}
          >
            {t('skip')}
          </Button>
        </Grid>
        <Grid item>
          <Button fullWidth color="primary" variant="contained" className={classes.saveButton} onClick={nextStep}>
            {lastStep ? t('finish') : t('next')}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default Onboarding;
